<template>
  <div class="w-container w-justify-content-start w-col">
    <div
      class="w-item w-container w-justify-content-start w-col card-from-bottom height-min-content"
    >
      <div
        v-if="loading"
        class="w-container w-item w-align-center text-center w-justify-content-center w-col card-from-bottom overflow-auto"
      >
        <v-progress-circular
          indeterminate
          color="secondary"
        ></v-progress-circular>
      </div>
      <div
        v-if="
          !loading &&
          paymentConfig &&
          paymentConfig.mercadopago &&
          paymentConfig.mercadopago.qr_topup
        "
        class="w-container w-no-flex w-justify-content-center w-col card-from-bottom overflow-auto"
      >
        <div
          class="w-no-flex user-text text-justify text-body-2 mx-3 text-left grey--text text--darken-1 font-weight-medium"
        >
          {{ $t("mercadopago.qr_placement") }}
        </div>
        <card-image class="w-no-flex card-image" viewBox="0 0 88 65" />
        <div
          class="w-no-flex user-text text-justify text-body-2 mx-3 pb-2 text-left grey--text text--darken-1 font-weight-medium"
          v-html="$t('mercadopago.recharge_instructions')"
        ></div>
        <div class="w-no-flex w-container w-row w-justify-content-center mb-2">
          <v-btn
            fab
            name="Download on Google Play"
            color="primary"
            icon
            text
            href="https://play.google.com/store/apps/details?id=com.mercadopago.wallet"
            target="_blank"
          >
            <v-icon>fab fa-google-play</v-icon>
          </v-btn>
          <v-btn
            fab
            name="Download on App Store"
            color="primary"
            icon
            text
            href="https://itunes.apple.com/ar/app/mercado-pago-recargar-celular/id925436649?mt=8"
            target="_blank"
          >
            <v-icon>fab fa-app-store</v-icon>
          </v-btn>
        </div>
        <v-btn
          :dark="$store.getters.themeOnSecondary === 'dark'"
          :light="$store.getters.themeOnSecondary === 'light'"
          color="secondary"
          rounded
          @click="
            $router.push({
              name: routeNames.TOPUP,
              params: { paymentMethod: paymentMethods.MERCADOPAGO.key },
            })
          "
          >{{ $t("mercadopago.app_recharge") }}</v-btn
        >
      </div>
    </div>
  </div>
</template>

<script>
import config from "../config/app-config";
import CardImage from "../assets/Card.svg";
export default {
  props: ["auth", "routeNames"],
  data() {
    return {
      paymentMethods: config.PAYMENT_METHODS,
      paymentConfig: null,
      loading: false,
    };
  },
  components: {
    CardImage,
  },
  methods: {
    getEconomics() {
      this.loading = true;
      const context = this;
      this.$store.dispatch("getEconomics", context).then((economics) => {
        context.paymentConfig = economics;
        context.loading = false;
      });
    },
  },
  computed: {
    backRoute() {
      var route = this.routeNames.WALLET;
      if (this.paymentConfig && this.paymentConfig.paylands.enabled) {
        route = this.routeNames.PAYMENT_METHOD;
      }
      return route;
    },
  },
  created() {
    this.getEconomics();
  },
};
</script>

<style scoped lang="scss">
.body-2,
.body-1 {
  height: min-content;
  color: rgba(0, 0, 0, 0.6) !important;
}
.card-image {
  width: 60%;
  padding: 20px;
  height: auto;
  margin-left: auto;
  margin-right: auto;
}
</style>
